/**
 * roles selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

import { Role } from './types';

interface State {
    roles: {
        [key: number]: Role;
    };
}

interface Props {
    roleId?: number | string;
}

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectRoles = (state: State): Record<string, Role> => state.roles;
const selectRoleId = (
    state: State,
    props: Props
): number | string | undefined => props.roleId && `${props.roleId}`;

const selectRolesArray = createDeepEqualSelector(selectRoles, (rolesState) =>
    Object.values(rolesState)
);

const selectRoleIds = createDeepEqualSelector(selectRoles, (rolesState) =>
    Object.keys(rolesState).map(Number)
);

const selectRole = createDeepEqualSelector(
    selectRoles,
    selectRoleId,
    (rolesState, roleId) => roleId && rolesState[roleId]
);

const makeSelectRoleValue = (field: keyof Role): any =>
    createDeepEqualSelector(
        selectRole,
        (roleState) => roleState && roleState[field]
    );

export {
    selectRoles,
    selectRolesArray,
    selectRoleIds,
    selectRole,
    makeSelectRoleValue
};
